var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Typography } from '../../../../foundations/typography';
import styles from './FieldLabel.module.scss';
export var FieldLabel = function (_a) {
    var _b;
    var className = _a.className, id = _a.id, _c = _a.indicateOptional, indicateOptional = _c === void 0 ? false : _c, _d = _a.indicateRequired, indicateRequired = _d === void 0 ? false : _d, label = _a.label, _e = _a.labelHidden, labelHidden = _e === void 0 ? false : _e, labelForId = _a.labelForId, props = __rest(_a, ["className", "id", "indicateOptional", "indicateRequired", "label", "labelHidden", "labelForId"]);
    return (React.createElement("label", __assign({}, props, { className: classNames(styles.label, className, (_b = {},
            _b[styles.srOnly] = labelHidden,
            _b)), htmlFor: labelForId, id: id }),
        React.createElement(Typography, { element: "span", noMargins: true, styleAs: "paragraphHeading" }, label),
        indicateRequired && (React.createElement(Typography, { element: "span", noMargins: true, styleAs: "paragraphExtraSmall" },
            React.createElement("span", { "aria-hidden": "true" }, "*"),
            React.createElement("span", { className: styles.srOnly }, "required"))),
        indicateOptional && (React.createElement(Typography, { element: "span", noMargins: true, styleAs: "paragraphExtraSmall" }, "(optional)"))));
};
//# sourceMappingURL=FieldLabel.js.map